import ReactPaginate from 'react-paginate';
import endpoints from '../../config/endpoints';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Sidebar } from '../Layout/Sidebar';

const Car = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [query, setQuery] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e.title.toLowerCase().includes(query.toLowerCase())).slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));

      const res = await restApi(endpoints.car.index + id, true).delete({});

      if(res.code == 204){
        Swal.fire({
          title: 'موفق',
          text: ' خودرو  با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }

      dispatch(setLoading(false));
      fetchData()
    }
  }

  const list = () => {
    const rows = [];

    currentItems.map((car: any, index) => {
      rows.push(
        <tr
          className={`dashTr2 ${index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}`}
          key={`car-${car.id}-${index}`}
        >
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(car.id) }></i>
            <i className="edit clickable" onClick={() => navigate("/car/edit/" + car.id)}></i>
          </td>
          <td className="">{car.slug}</td>
          <td className="">{car.title}</td>
          <td>{index + 1}</td>
        </tr>
      )
    })

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.car.index, true).get();

    if(res.code == 200){
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return(

    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست خودرو </h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable"  onClick={() => navigate('/car/add')}>
            <p>افزودن خودرو جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input:any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="alternating-table listTable">
          <thead>
          <tr className="dashTr1 firstTR">
            <th>عملیات</th>
            <th>اسلاگ</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
        <ReactPaginate
          breakLabel="..."
          nextLabel="بعدی >"
          onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< قبلی"
          renderOnZeroPageCount={null}
          className="pagination"
          pageClassName="paginationBreak"
          previousClassName="paginationBreak"
          nextClassName="paginationBreak"
          activeClassName="paginationActive"
        />
      </main>
      </body>
    </>
  )
}
export default Car;